<template>
  <InfoModalTrigger title="Inventory management">
    <p class="mb-2"><strong>If enabled</strong></p>
    <p class="mb-2">Scan&amp;Go scan will decrease the inventory of correspondent products parsed from shipment description.</p>
    <p class="mb-2">If there is not enough inventory error will be thrown, stock will not go negative for the insufficient SKUs, stock will also not be decreased for SKUs with enough on hand value, but shipment will be marked as received.</p>
    <p class="mb-0">You can add/remove inventory data even if this setting is disabled.</p>
  </InfoModalTrigger>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import InfoModalTrigger from '@/views/Components/Elements/InfoModalTrigger.vue'

export default defineComponent({
  name: 'InventoryManagementInfoModal',
  components: { InfoModalTrigger },
})
</script>
